import styles from "./index.module.scss";
import Image from "next/image";

export default function ImageCardGrid({
  data
}) {
  const {
    title = "",
    subTitle = "",
    images = [],
  } = data || {};

  const items = images.map((item) => ({
    id: item?.sys?.id,
    title: item?.fields?.name,
    image: item?.fields?.assets?.[0]?.fields?.file?.url
      ? `https:${item.fields.assets[0].fields.file.url}`
      : "",
    link: item?.fields?.ctas?.[0]?.fields?.url || "#",
    buttonLabel:
      item?.fields?.ctas?.[0]?.fields?.label || "SELECT",
    openerType : item?.fields?.ctas?.[0]?.fields?.openerType,
  }));

  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        
        {/* TITLE */}
        <div className={styles.header}>
          <h2>{title}</h2>
          {subTitle && (
            <p className={styles.subTitle}>{subTitle}</p>
          )}
        </div>
        {/* GRID */}
        <div className={styles.grid}>
          {items.map((item) => (
            <div key={item.id} className={styles.card}>
              <figure>
                
                {/* IMAGE */}
                <div className={styles.imageWrapper}>
                  <Image
                    src={item.image}
                    alt={item.title}
                    fill
                  />
                </div>
                {/* CONTENT */}
                <figcaption>
                  <h3 className={styles.cardTitle}>
                    {item.title}
                  </h3>
                    <a
                      href={item.link}
                      className={styles.selectBtn}
                      target={item.openerType === "New Tab" ? "_blank" : "_self"}
                    >
                      SELECT
                    </a>
                </figcaption>
              </figure>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}